import React from "react";
import styles from "./Footer.module.css";
import fb from "../../assets/home/facebook.png";
import linkdin from "../../assets/home/linkdin.png";
import insta from "../../assets/home/insta.png";

const Footer = () => {
  return (
    <>
      <div
        style={{
          backgroundColor: "#2b2b2b",
          paddingTop: "89px",
          paddingBottom: "90px",
        }}
      >
        <div className="container Footer">
          <div className="row">
            <div className={`col-lg-3 col-sm-6 ${styles.contain}`}>
              <p className={styles.logo}>A-minute</p>
              <p className={styles.text}>
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
              </p>
              <p className={styles.text}>Lorem ipsum dolor sit amet</p>
              <p className={styles.text}>Lorem ipsum dolor sit amet</p>
              <div className={styles.social_logo}>
                <a href="https://www.facebook.com/profile.php?id=61554672527402">
                  <img src={fb} alt="fb" className={styles.img} />
                </a>
                <a href="https://www.instagram.com/aminutesportsbar/">
                  <img src={insta} alt="in" className={styles.img} />
                </a>
              </div>
            </div>

            <div className={`col-lg-3 col-sm-6 ${styles.contain}`}>
              <p className={styles.head}>Services</p>
              <p className={styles.text}>Snooker table</p>
              <p className={styles.text}>8 ball pool</p>
              <p className={styles.text}>Indoor Games and Bar</p>
            </div>

            <div className={`col-lg-3 col-sm-6 ${styles.contain}`}>
              <p className={styles.head}>Location</p>
              <p className={styles.text}>Pyafal, Maruhity, Kathmandu </p>
              <p className={styles.text}>aminutesnooker@example.com</p>
              <p className={styles.text}>(671) 555-0110</p>
            </div>

            <div className={`col-lg-3 col-sm-6 ${styles.contain}`}>
              <p className={styles.head}>Opening Hour</p>
              <p className={styles.text}>Mon - Sat : 8:00 - 17:00</p>
              <p className={styles.text}>Sun : Closed</p>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{ backgroundColor: "#2b2b2b", borderTop: "solid 1px #707070" }}
      >
        マジック All Rights Reserved. &nbsp;
        <p className={styles.bottom}>
          Copyright &copy; 2023&nbsp; Aminute Snooker <br></br>All Rights
          reserved
        </p>
        <p className={styles.bottom}>Coastal Nepal</p>
      </div>
    </>
  );
};
export default Footer;
